import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule }   from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { Ng4GeoautocompleteModule } from 'ng4-geoautocomplete';

import { AppComponent } from './app.component';
import { QuestionProcessingService } from './services/question-processing.service';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { EmployeeSearchComponent } from './employee-search/employee-search.component';
import { EsignComponent } from './esign/esign.component';
import { TouchEventService } from './services/touch-event.service';
import { PlacesService } from './services/places.service';
import { LoaderComponent } from './loader/loader.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { DennysFlowComponent } from './dennys-flow/dennys-flow.component';
import { DennysFlow2Component } from './dennys-flow2/dennys-flow2.component';
import { DennysFlow3Component } from './dennys-flow3/dennys-flow3.component';
import { CheckBoxComponent } from './utility-components/check-box/check-box.component';
import { YesNoComponent } from './utility-components/yes-no/yes-no.component';
import { DennysFlow4Component } from './dennys-flow4/dennys-flow4.component';
import { DennysFlow5Component } from './dennys-flow5/dennys-flow5.component';
import { DennysFlow6Component } from './dennys-flow6/dennys-flow6.component';
import { QuestionViewerSingleComponent } from './question-viewer-single/question-viewer-single.component';
// import { DennysFlowSingleComponent } from './dennys-flow-single/dennys-flow-single.component';
import { DynamicInputComponent } from './utility-components/dynamic-input/dynamic-input.component';
import { ButtonsInputComponent } from './utility-components/buttons-input/buttons-input.component';
import { Flow7Component } from './flow7/flow7.component';
import { IntegrationDebugComponent } from './integration-debug/integration-debug.component';
import { HttpClientModule } from '@angular/common/http';
import { IntegrationService } from './services/integration.service';
import { QuestionViewerComponent } from './question-viewer/question-viewer.component';
import { DynamicQuestionService } from './services/dynamic-question.service'
import { Configuration } from '../../app.config';
import { IntegrationCompleteComponent } from './integration-complete/integration-complete.component';

const routes: Routes = [
  { path: 'screen/:applicantId', component: DisclaimerComponent },
  { path: 'integration/:profileId', component: DisclaimerComponent },
  { path: 'summary/:profileId', component: IntegrationCompleteComponent },
  { path: 'summary/:profileId/:returnUrl', component: IntegrationCompleteComponent },
  { path: 'summary/:profileId/:returnUrl/:returnUrl2', component: IntegrationCompleteComponent },
  { path: '', component: DisclaimerComponent },
  { path: 'dennys', component: DisclaimerComponent },
  { path: 'debug/:applicantId', component: IntegrationDebugComponent },
  { path: 'esign', component: EsignComponent },
  { path: 'landing', component: LandingPageComponent },
  { path: 'lookup', component: EmployeeSearchComponent },
  { path: 'd1', component: DennysFlowComponent },
  { path: 'd2', component: DennysFlow2Component },
  { path: 'd3', component: DennysFlow3Component },
  { path: 'd4', component: Flow7Component },
  { path: 'd5', component: DennysFlow4Component },
  { path: 'd6', component: DennysFlow5Component },
  { path: 'd7', component: DennysFlow6Component },
  { path: 'survey', component: QuestionViewerComponent },
  { path: 'surveySingle', component: QuestionViewerSingleComponent }
  // { path: '', component: LoaderComponent }
  // { path: 'dennys-spa', component: DennysFlowSingleComponent },
];


@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    DisclaimerComponent,
    EmployeeSearchComponent,
    EsignComponent,
    LoaderComponent,
    DennysFlowComponent,
    DennysFlow2Component,
    DennysFlow3Component,
    CheckBoxComponent,
    YesNoComponent,
    DennysFlow4Component,
    DennysFlow5Component,
    DennysFlow6Component,
    // DennysFlowSingleComponent,
    DynamicInputComponent,
    ButtonsInputComponent,
    Flow7Component,
    IntegrationDebugComponent,
    QuestionViewerComponent,
    QuestionViewerSingleComponent,
    IntegrationCompleteComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    Ng4GeoautocompleteModule.forRoot(),
    RouterModule.forRoot(routes),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    HttpClientModule
  ],
  providers: [
    QuestionProcessingService,
    TouchEventService,
    PlacesService,
    IntegrationService,
    DynamicQuestionService,
    Configuration
  ],
  bootstrap: [AppComponent]
})
export class ScreeningModule { }



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/app.module.ts